/* @ngInject */
const areaFields = (
  areaLabels,
  icons,
  types
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: areaLabels.fields.id.text,
    icon: icons.id,
    output: false,
  }

  self.name = {
    ref: 'name',
    label: areaLabels.fields.name.text,
    icon: icons.area.name,
    type: types.text(),
    required: true,
    unique: true,
    nature: 'area',
    messages: areaLabels.fields.name.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.totalLength = {
    ref: 'totalLength',
    label: areaLabels.fields.totalLength.text,
    icon: icons.length,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: true, },
    },
  }

  self.usedLength = {
    ref: 'usedLength',
    label: areaLabels.fields.usedLength.text,
    icon: icons.length,
    output: {
      sortable: true,
    },
  }

  self.ratioUsedLength = {
    ref: 'ratioUsedLength',
    label: areaLabels.fields.usedLength.text,
    icon: icons.length,
    output: {
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.availableLength = {
    ref: 'availableLength',
    label: areaLabels.fields.availableLength.text,
    icon: icons.length,
    output: {
      sortable: true,
    },
  }

  self.ratioAvailableLength = {
    ref: 'ratioAvailableLength',
    label: areaLabels.fields.availableLength.text,
    icon: icons.length,
    output: {
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.railwayNumber = {
    ref: 'railwayNumber',
    label: areaLabels.fields.railwayNumber.text,
    icon: icons.railway,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.selectArea = {
    ref: 'selectArea',
    label: areaLabels.fields.selectArea.text,
    type: types.select,
    options: 'area as area.name for area',
    order: 'name.toString()',
    choice: areaLabels.fields.selectArea.choice,
    messages: areaLabels.fields.selectArea.messages,
    output: {
      table: false,
      details: false,
      excel: false,
    },
  }

  self.isReal = {
    ref: 'isReal',
    label: areaLabels.fields.isReal.text,
    icon: icons.isReal,
    output: {
      table: {
        prefill: false,
      },
    },
  }

  return self
}
export default areaFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/resources/fields.resource.js